export const any = (...conditions) => function any() {
  return conditionArguments => conditions.some(condition => condition(conditionArguments))
}

export const loggedIn = () => function loggedIn({ store }) {
  return store.getters.isAuth
}

export const hasRole = (...roles) => function hasRole({ store }) {
  return store.getters.hasRole(...roles)
}
